//This file is automatically rebuilt by the Cesium build process.
export default "const float czm_solarRadius = 695500000.0;\n\
";
